<template>
    <div class="dm-container">
        <div class="dm-sidebar" :class="{ 'collapsed': isCollapsed }">
            <div class="sidebar-header">
                <h3 v-if="!isCollapsed">DISPOSITIVOS MÉDICOS</h3>
                <h3 v-else>DM</h3>
            </div>
            <nav class="sidebar-nav">
                <ul class="nav-menu">
                    <li class="nav-item">
                        <router-link to="/dm/dashboard" class="nav-link" active-class="active">
                            <i class="el-icon-s-home"></i>
                            <span v-if="!isCollapsed">Dashboard</span>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/dm/registros" class="nav-link" active-class="active">
                            <i class="el-icon-document-add"></i>
                            <span v-if="!isCollapsed">Registros</span>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/dm/medicos" class="nav-link" active-class="active">
                            <i class="el-icon-user-solid"></i>
                            <span v-if="!isCollapsed">Médicos</span>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/dm/pruebas" class="nav-link" active-class="active">
                            <i class="el-icon-s-platform"></i>
                            <span v-if="!isCollapsed">Pruebas</span>
                        </router-link>
                    </li>
                </ul>
            </nav>
            <div class="sidebar-footer">
                <div class="user-info" v-if="!isCollapsed">
                    <span>{{ userName }}</span>
                    <button @click="logout" class="logout-btn">
                        <i class="el-icon-switch-button"></i>
                        Salir
                    </button>
                </div>
                <div class="footer-controls">
                    <button @click="toggleCollapse" class="toggle-btn">
                        <i :class="isCollapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="dm-content" :class="{ 'expanded': isCollapsed }">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DispositivosMedicosLayout',
    data() {
        return {
            isCollapsed: false,
            userName: window.sessionStorage.getItem('nombre') || 'Usuario DM'
        }
    },
    methods: {
        toggleCollapse() {
            this.isCollapsed = !this.isCollapsed;
        },
        logout() {
            window.sessionStorage.clear();
            this.$router.push('/');
        }
    }
}
</script>

<style lang="scss" scoped>
.dm-container {
    display: flex;
    height: 100vh;
    width: 100%;
    position: relative;
}

.dm-sidebar {
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    width: 250px;
    background: linear-gradient(135deg, #122940 0%, #5274CE 100%);
    color: white;
    display: flex;
    flex-direction: column;
    z-index: 1000;
    transition: all 0.3s ease;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);

    &.collapsed {
        width: 60px;

        .nav-link {
            justify-content: center;
            padding: 15px 10px;

            i {
                margin-right: 0;
                font-size: 20px;
            }

            span {
                display: none;
            }
        }

        .sidebar-header h3 {
            font-size: 12px;
        }

        .user-info {
            display: none;
        }
    }

    .sidebar-header {
        padding: 20px;
        text-align: center;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);

        h3 {
            margin: 0;
            font-size: 16px;
            font-weight: bold;
            color: white;
        }
    }

    .sidebar-nav {
        flex: 1;
        padding: 20px 0;

        .nav-menu {
            list-style: none;
            margin: 0;
            padding: 0;

            .nav-item {
                margin: 0;

                .nav-link {
                    display: flex;
                    align-items: center;
                    padding: 15px 20px;
                    color: rgba(255, 255, 255, 0.8);
                    text-decoration: none;
                    transition: all 0.3s ease;
                    border-left: 3px solid transparent;

                    i {
                        font-size: 18px;
                        margin-right: 15px;
                        min-width: 20px;
                    }

                    span {
                        font-size: 14px;
                        font-weight: 500;
                    }

                    &:hover {
                        background-color: rgba(255, 255, 255, 0.1);
                        color: white;
                        border-left-color: #5274CE;
                    }

                    &.active {
                        background-color: rgba(255, 255, 255, 0.15);
                        color: white;
                        border-left-color: #5274CE;
                    }
                }
            }
        }
    }

    .sidebar-footer {
        padding: 15px;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        display: flex;
        flex-direction: column;
        gap: 15px;

        .user-info {
            text-align: center;
            order: 1;

            span {
                display: block;
                font-size: 12px;
                color: rgba(255, 255, 255, 0.9);
                margin-bottom: 8px;
                font-weight: 500;
            }

            .logout-btn {
                background: rgba(244, 67, 54, 0.8);
                border: none;
                color: white;
                padding: 6px 10px;
                border-radius: 4px;
                cursor: pointer;
                font-size: 11px;
                transition: all 0.3s ease;
                width: 100%;

                &:hover {
                    background-color: rgba(244, 67, 54, 1);
                    transform: translateY(-1px);
                }

                i {
                    margin-right: 5px;
                }
            }
        }

        .footer-controls {
            order: 2;
            display: flex;
            justify-content: center;

            .toggle-btn {
                background: rgba(255, 255, 255, 0.1);
                border: 1px solid rgba(255, 255, 255, 0.2);
                color: white;
                font-size: 14px;
                cursor: pointer;
                padding: 8px;
                border-radius: 6px;
                transition: all 0.3s ease;
                width: 35px;
                height: 35px;
                display: flex;
                align-items: center;
                justify-content: center;

                &:hover {
                    background-color: rgba(255, 255, 255, 0.2);
                    border-color: rgba(255, 255, 255, 0.3);
                    transform: scale(1.05);
                }
            }
        }
    }
}

.dm-content {
    flex: 1;
    margin-left: 250px;
    transition: margin-left 0.3s ease;
    background-color: #f5f5f5;
    overflow-y: auto;
    width: calc(100% - 250px);

    &.expanded {
        margin-left: 60px;
        width: calc(100% - 60px);
    }
}

// Responsive
@media (max-width: 768px) {
    .dm-sidebar {
        width: 60px;

        .sidebar-header h3 {
            display: none;
        }

        .nav-link span {
            display: none;
        }

        .user-info {
            display: none;
        }
    }

    .dm-content {
        margin-left: 60px;
    }
}
</style>